import PropTypes from "prop-types"
import ModelSelector from "modules/model-selector"
import { find } from "lodash"
import { DATE } from "helpers/shapes"

function Subnav({ modelId, setModel, models, resourceId, resourceType, portfolioDates, disabled }) {
  const selectedModel = find(models, model => model.id === modelId)

  return <div className="research-topic-root-subnav">
    <ModelSelector
      noSpinner
      modelId={modelId}
      modelName={selectedModel ? selectedModel.name : modelId}
      setModel={setModel}
      resourceType={resourceType}
      resourceId={resourceId}
      assetAvailability={portfolioDates}
      disableUnderline
      disabled={disabled}
    />
  </div>
}

Subnav.propTypes = {
  modelId: PropTypes.string.isRequired,
  setModel: PropTypes.func.isRequired,
  models: PropTypes.array.isRequired,
  resourceId: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  resourceType: PropTypes.oneOf(["security", "portfolio"]).isRequired,
  disabled: PropTypes.bool,
  portfolioDates: PropTypes.shape({
    earliest: DATE,
    latest: DATE,
  }),
}

export default Subnav
